import React, { useEffect, useState } from "react";
import api from "../../../../utils/api";
import "./AdminScholarships.css";

const AdminScholarships = () => {
    const [scholarships, setScholarships] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchScholarships = async () => {
        try {
            const { data } = await api.get("/scholarships/all");
            setScholarships(data);
        } catch (error) {
            console.error(error);
            alert("Failed to fetch scholarships");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchScholarships();
    }, []);

    const updateStatus = async (id, status) => {
        try {
            await api.put(`/scholarships/update/${id}`, { status });
            fetchScholarships();
        } catch (error) {
            alert("Status update failed");
        }
    };

    if (loading) return <p className="loading-text">Loading Scholarships...</p>;

    return (
        <div className="admin-scholarships">
            <h1>Scholarship Applications</h1>

            <table>
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Course</th>
                        <th>Type</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>

                <tbody>
                    {scholarships.map((s) => (
                        <tr key={s._id}>
                            <td data-label="Name">{s.name}</td>
                            <td data-label="Email">{s.email}</td>
                            <td data-label="Course">{s.course}</td>
                            <td data-label="Type">{s.scholarshipType}</td>
                            <td data-label="Status">
                                <span className={`status ${s.status.toLowerCase()}`}>
                                    {s.status}
                                </span>
                            </td>
                            <td data-label="Action">
                                <button
                                    onClick={() => updateStatus(s._id, "Approved")}
                                    className="approve btn-scholarship"
                                >
                                    Approve
                                </button>
                                <button
                                    onClick={() => updateStatus(s._id, "Rejected")}
                                    className="reject btn-scholarship"
                                >
                                    Reject
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>

            </table>
        </div>
    );
};

export default AdminScholarships;
